import React from "react";
import { makeBEM } from "utils";

const bem = makeBEM("layout-content");

export const LayoutContent: React.FC<{}> = ({ children }) => {
  return <div className={bem()}>{children}</div>;
};
